import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cfpBaseUrl, wfsBaseUrl } from '../../network/urls';
import { convertDateYYYYMMDD } from '../../services/Functions';

const initialState = {
    data: [],
    pageNumber: 1,
    pageSize: 20,
    subDivisionCode: '',
    status: 'Working',
    isLoading: false,
    totalPages: null,
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchPaginatedWorkingComplaints = createAsyncThunk(
    'complaints/fetchWorkingComplaints',
    async ({ pageSize, pageNumber, subDivisionCode, status, dateFrom, dateTo }, { getState }) => {
        const { auth } = getState();
        const { wmsPrivateToken, token } = auth;


        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            "pageNumber": pageNumber,
            "pageSize": pageSize,
            "officeCode": subDivisionCode,
            "status": status,
            "dateFrom": dateFrom || convertDateYYYYMMDD(new Date()),
            "dateTo": dateTo || convertDateYYYYMMDD(new Date()),
        });
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + 'lineComplaints/getAllComplaintsByStatusAndOfficeCode', requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Complaints API issue!');
        }

        const result = await response.json();
        if (result.Message === "Data Not Found.") {
            throw new Error(result.Message, 'printing error message' || 'Unable to fetch stats!');
        }

        result.data.sort((a, b) => {
            const dateA = new Date(a.ModificationDateTime);
            const dateB = new Date(b.ModificationDateTime);
            return dateB - dateA;
        });
        return result;
    }
);

const workingComplaintsPaginatedSlice = createSlice({
    name: 'workingComplaintsPaginated',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.pageNumber += 1;
        },
        previousPage(state) {
            if (state.pageNumber > 1) {
                state.pageNumber -= 1;
            }
        },
        firstPage(state) {
            state.pageNumber = 1;
        },
        lastPage(state, action) {
            state.pageNumber = action.payload;
        },
        resetState(state) {
            state.data = [];
            state.pageNumber = 1;
            state.pageSize = 20;
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedWorkingComplaints.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedWorkingComplaints.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.data) {
                    state.data = action.payload.data;
                } else {
                    state.data = []
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1
                }
                state.totalRecords = action.payload.totalRecords;
                state.pageNumber = action.meta.arg.pageNumber;
                state.error = null;
            })
            .addCase(fetchPaginatedWorkingComplaints.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
                state.totalPages = null;
                state.totalRecords = null;
            });
    },
});

export const { nextPage, previousPage, firstPage, lastPage, resetState } = workingComplaintsPaginatedSlice.actions;

export default workingComplaintsPaginatedSlice.reducer;
